import type * as Common from '@piccolohealth/pbs-common';
import { ChakraV3, DndKitSortable, DragHandle, dataAttr, Sortable } from '@piccolohealth/ui';
import React from 'react';
import { showModal } from '../../../components/generic/Modal';
import { ParticipantFieldGroupTemplateDeleteModal } from './ParticipantFieldGroupTemplateDeleteModal';

interface Props {
  fieldGroupTemplate: Common.ParticipantFieldGroupTemplate;
  isActive?: boolean;
  onClick: () => void;
  onEdit: (name: string) => void;
  onRemove: () => void;
}

export const ParticipantFieldGroupTemplate = (props: Props) => {
  const { fieldGroupTemplate, isActive, onClick, onEdit } = props;

  const [value, setValue] = React.useState(fieldGroupTemplate.name);

  const { attributes, setNodeRef, listeners, transform, transition } = DndKitSortable.useSortable({
    id: fieldGroupTemplate.id,
  });

  React.useEffect(() => {
    setValue(fieldGroupTemplate.name);
  }, [fieldGroupTemplate.name]);

  const onRemove = () => {
    showModal(ParticipantFieldGroupTemplateDeleteModal, {
      participantFieldGroupTemplateId: fieldGroupTemplate.id,
      onDelete: props.onRemove,
    });
  };

  return (
    <ChakraV3.Box
      onClick={onClick}
      className='group'
      rounded='lg'
      px={2}
      _hover={{ bg: 'gray.100' }}
      _active={{ bg: 'gray.100' }}
      data-active={dataAttr(isActive)}
    >
      <Sortable ref={setNodeRef} transform={transform} transition={transition}>
        <ChakraV3.Editable.Root
          value={value}
          onValueChange={({ value }) => setValue(value)}
          onValueCommit={({ value }) => onEdit(value)}
          activationMode='none'
        >
          <ChakraV3.HStack w='full' h='full' gap={1}>
            <DragHandle listeners={listeners} attributes={attributes} size='xs' />
            <ChakraV3.HStack w='full' fontWeight='semibold'>
              <ChakraV3.Editable.Preview w='full' />
              <ChakraV3.Editable.Input />
              <ChakraV3.Spacer />
              <ChakraV3.EditableControls onRemove={onRemove} />
            </ChakraV3.HStack>
          </ChakraV3.HStack>
        </ChakraV3.Editable.Root>
      </Sortable>
    </ChakraV3.Box>
  );
};
